import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconDots = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 37" size={size} {...props}>
        <StyledPath
            color={color}
            fillRule="evenodd"
            d="M19 16a2 2 0 110 4 2 2 0 010-4zm-7 0a2 2 0 110 4 2 2 0 010-4zm14 0a2 2 0 110 4 2 2 0 010-4z"
        />
    </StyledSvg>
);
